// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"3":"c605cf91","16":"c5cf2f9e","99":"d5f00876","230":"a59bc879","252":"f64abf1d","401":"ed546248","453":"1e758957","726":"2bc01894","906":"dbd58656"}[chunkId] + ".chunk.js";
};